export const MARKETPLACE_MATOMO_EVENT_CATEGORY_AFTER_SALES = 'AfterSales';
export const MARKETPLACE_MATOMO_EVENT_CATEGORY_BILLING = 'Billing';
export const MARKETPLACE_MATOMO_EVENT_CATEGORY_INTERVAL = 'Interval';
export const MARKETPLACE_MATOMO_EVENT_CATEGORY_PAYMENT = 'Payment';
